<div class="offline-container flex-col">
  <h1>{{ 'dottnet.menu.offline' | translate }}</h1>
  Il sito è momentaneamente offline. Tentativi: {{ currentInterval }}
  @if (backendError$ | async; as error) {
    <pre><p>{{error | json}}</p></pre>
  }
</div>
